module.exports = __webpack_public_path__ + "img/avatar-novo.f79b0529.svg";